import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vue-cropper/dist/index.css'
import '@/assets/styles/index.scss'
import '@/assets/styles/main.scss'
import '@/assets/styles/render.scss'

import VueCropper from 'vue-cropper';
import draggable from 'vuedraggable'
import ElementPlus from 'element-plus'
import '$md-base-tools/editor/index.css'
import 'element-plus/dist/index.css'
import '$md-base-ui/src/assets/styles/element-variarbles.scss'
import '@/assets/styles/element-variarbles.scss'
import locale from "element-plus/lib/locale/lang/zh-cn";
import * as ElIcons from '@element-plus/icons-vue'

import imgUrlFilter from '$md-base-tools/imgUrlFilter'

import "$md-base-ui/md-ui-v3/style.css"
import MDUIV3 from "$md-base-ui/md-ui-v3/md-ui-v3"

import dayjs from 'dayjs'
dayjs().format()
import tools from '@/utils/tools.js'
const app = createApp(App)

// 神策
import '@/service/sensors'
var sensors = require('sa-sdk-javascript')
app.config.globalProperties.sensors = sensors
app.config.globalProperties.$dayjs = dayjs

for (const name in ElIcons){
	app.component(name, ElIcons[name])
}
app.component('draggable', draggable)
app.use(store).use(router).use(VueCropper).use(ElementPlus, {locale}).use(MDUIV3)
app.config.globalProperties.$imgUrlFilter = imgUrlFilter

var ifFirst = true
import { beforeRouter } from '@/utils/mapMenu.js'
router.beforeEach(async (to) => {
    // acp单独的编辑器页面参数
    if(to.query.acpToken){
        await store.dispatch('setEditorAcpToken',to.query.acpToken);
        if (to.query.editor_pro_id) {
            await store.dispatch('setEditorProId',to.query.editor_pro_id);
        }
        if (to.query.version_id) {
            await store.dispatch('setEditorVersionId',to.query.version_id);
        }
    }
    console.log('store.state.user.user_id', store.state.user.user_id)
	if (!store.state.user.user_id) {
        await store.dispatch('getCpUserInfo')
    }

    if (to.fullPath.indexOf('/project_manage_full/') > -1) {
        ifFirst = false
    } 
    if (ifFirst) {
        ifFirst = false
        await store.dispatch('getProList', 1)
        if (store.state.project.proList && store.state.project.proList.length) {
            if (to.path == '/project_manage/index') {
                // 如果第一个是准备中的项目
                if (store.state.project.proList[0].temp_id && store.state.project.proList[0].temp_id != 0) {
                    store.commit('updataProInfo', {
                        id: store.state.project.proList[0].temp_id,
                        info: store.state.project.proList[0],
                    });
                    store.commit('updataAuthority', true);
                    router.replace(`/project_manage/index/temp/${store.state.project.proList[0].temp_id}`)
                } else {
                    router.replace(`/project_manage/index/${store.state.project.proList[0].id}`)
                }
            }
        } 
    }
    if (to.fullPath.indexOf('project_manage') > -1) {


        if (to.fullPath.indexOf('/project_manage_full/') > -1) {
            //do nothing
        } else {
            await beforeRouter(to)
        }
    }
    if (to.name) {
        document.title = to.meta.title || to.name
    }
    window.scrollTo(0, 0);
})
window.alert = function(message) {
    tools.confirm(message);
}
app.mount('#app')
